import React, { useState } from "react";
import { useForm } from "react-hook-form";

const Tds = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [result, setResult] = useState(null);
  const [amount, setAmount] = useState("");
  const [tdsRate, setTdsRate] = useState("");
  const [tdsAmount, setTdsAmount] = useState(null);

  const handleCalculateTDS = () => {
    const tds = (amount * tdsRate) / 100;
    setTdsAmount(tds);
  };

  const TDS_RATES = {
    salary: 0.1,
    professionalFees: 0.1,
    contractualPayment: 0.02,
    rent: 0.1,
  };

  const calculateTDS = (data) => {
    const { paymentAmount, paymentType } = data;
    const rate = TDS_RATES[paymentType] || 0;
    const tdsAmount = paymentAmount * rate;
    const netPayment = paymentAmount - tdsAmount;

    setResult({ tdsAmount, netPayment });
  };

  return (
    <>
      <div className="container my-5">
        <div className="card shadow-lg border-0">
          <div className=" bg-primary  text-center">
            <h4 className="text-white my-2">TDS Calculator</h4>
          </div>
          <div className="card-body p-4">
            <form onSubmit={handleSubmit(calculateTDS)}>
              <div className="mb-3">
                <label className="form-label">Payment Amount (₹)</label>
                <input
                  type="number"
                  {...register("paymentAmount", {
                    required: "Payment amount is required",
                    min: {
                      value: 1,
                      message: "Amount must be greater than 0",
                    },
                  })}
                  className={`form-control ${
                    errors.paymentAmount ? "is-invalid" : ""
                  }`}
                  placeholder="Enter payment amount"
                />
                {errors.paymentAmount && (
                  <div className="invalid-feedback">
                    {errors.paymentAmount.message}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">Payment Type</label>
                <select
                  {...register("paymentType", {
                    required: "Select a payment type",
                  })}
                  className={`form-select ${
                    errors.paymentType ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select payment type</option>
                  <option value="salary">Salary</option>
                  <option value="professionalFees">Professional Fees</option>
                  <option value="contractualPayment">
                    Contractual Payment
                  </option>
                  <option value="rent">Rent</option>
                </select>
                {errors.paymentType && (
                  <div className="invalid-feedback">
                    {errors.paymentType.message}
                  </div>
                )}
              </div>

              <button type="submit" className="btn btn-primary w-100">
                Calculate TDS
              </button>
            </form>

            {result && (
              <div className="mt-4 alert alert-info">
                <h5 className="text-center">Calculation Results</h5>
                <hr />
                <p>
                  <strong>TDS Amount:</strong> ₹{result.tdsAmount.toFixed(2)}
                </p>
                <p>
                  <strong>Net Payable Amount:</strong> ₹
                  {result.netPayment.toFixed(2)}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <h2>TDS Calculator</h2>
        <div className="mb-3">
          <label htmlFor="amount" className="form-label">
            Payment Amount
          </label>
          <input
            type="number"
            id="amount"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label htmlFor="tdsRate" className="form-label">
            TDS Rate (%)
          </label>
          <input
            type="number"
            id="tdsRate"
            className="form-control"
            value={tdsRate}
            onChange={(e) => setTdsRate(e.target.value)}
          />
        </div>
        <button className="btn btn-primary" onClick={handleCalculateTDS}>
          Calculate TDS
        </button>

        {tdsAmount !== null && (
          <div className="mt-3">
            <h4>TDS Amount: ₹{tdsAmount.toFixed(2)}</h4>
          </div>
        )}
      </div>
    </>
  );
};

export default Tds;
